import { useEffect, useState } from "react";

import {
  MOBILE_WIDTH,
  TABLET_WIDTH,
  ScreenSizeTypes,
} from "../../config/constants";

/**
 * Method that returns the device screen type, Mobile, Tablet, Desktop
 * @returns {string}
 */
export const useScreenType = () => {
  const [screenType, setScreenType] = useState();

  let isSizeChecked = false;

  const updateScreenType = () => {
    if (window.outerWidth <= MOBILE_WIDTH) {
      setScreenType(ScreenSizeTypes.Mobile);
    } else if (window.outerWidth > MOBILE_WIDTH && window.outerWidth <= TABLET_WIDTH) {
      setScreenType(ScreenSizeTypes.Tablet);
    } else {
      setScreenType(ScreenSizeTypes.Desktop);
    }
  }

  useEffect(() => {
    if (typeof window === undefined) {
      return;
    }

    if (!isSizeChecked) {
      updateScreenType();

      isSizeChecked = true;
    }

    window.addEventListener("resize", updateScreenType);

    return () => window.removeEventListener("resize", updateScreenType);
  }, []);
  
  return screenType;
}
